import { useState, useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import QuickMenu from '../../components/feature/QuickMenu';
import { NewsItem } from '../../types/news';
import { useSEO, createWebPageSchema } from '../../utils/seo';

export default function NewsPage() {
  const [news, setNews] = useState<NewsItem[]>([]);

  useSEO({
    title: 'News & Insights - KR STUDIO | 최신 소식과 인사이트',
    description: 'KR스튜디오의 최신 소식과 교육 콘텐츠 제작 인사이트를 확인하세요. 이러닝 트렌드, 프로젝트 소식, 업계 동향을 전해드립니다.',
    keywords: '뉴스, 소식, 이러닝 트렌드, 콘텐츠 제작 인사이트, KR스튜디오 소식',
    canonical: '/news',
    schema: createWebPageSchema(
      'News & Insights - KR STUDIO',
      'KR스튜디오의 최신 소식과 교육 콘텐츠 제작 인사이트',
      '/news'
    ),
  });

  useEffect(() => {
    // localStorage에서 뉴스 데이터 가져오기
    const savedNews = localStorage.getItem('news');
    if (savedNews) {
      const newsItems: NewsItem[] = JSON.parse(savedNews);
      setNews(newsItems);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-32">
        <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/4e1d14221fe84f6fd34586df44267fe3.jpg')] bg-cover bg-center opacity-10"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-black mb-6">
              News & Insights
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              KR스튜디오의 최신 소식과 교육 콘텐츠 제작 인사이트를 만나보세요
            </p>
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          {news.length === 0 ? (
            <div className="text-center py-20">
              <i className="ri-newspaper-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-gray-500 text-lg">등록된 소식이 없습니다</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {news.map((item) => (
                <article
                  key={item.id}
                  className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
                >
                  {item.image && (
                    <div className="relative h-64 w-full overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  )}
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <span className="text-sm text-gray-500">{item.date}</span>
                      {item.author && (
                        <>
                          <span className="text-gray-300">•</span>
                          <span className="text-sm text-gray-500">{item.author}</span>
                        </>
                      )}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed line-clamp-3">
                      {item.summary}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
      <QuickMenu />
    </div>
  );
}
